import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React from "react";
import { instance } from "Actions/AxiosInstance";
import { ResponsiveLineCanvas } from "@nivo/line";
import DynamicForm from "Component/DynamicForm";
import { ResponsiveBarCanvas } from "@nivo/bar";
import { Doughnut } from "react-chartjs-2";
import { ResponsiveCalendarCanvas } from "@nivo/calendar";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import moment from "moment";
import {
  filterTypes,
  subfilterTypes,
  attendanceStateTypes,
  requestCountTypes,
} from "./constants";
import ShareIdea from "./ShareIdea";
import { getFormattedImageLink } from "../../../Utils";

class Expense extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      longestday: 10,
      ldsubfiltertypeid: 1,
      ldsubfilterids: [],
      employeeexpenditure: [],
      wffiltertypeid: 1,
      wfsubfiltertypeid: 1,
      wfsubfilterids: [],
      atfiltertypeid: 1,
      atsubfiltertypeid: 1,
      atsubfilterids: null,
      expenseheatmap: [],
      fromdate: "",
      todate: "",
      expensedistribution: [],
      averageexpense: 0,
      highestexpenditurelocation: null,
      maximumexpenditurmonth: null,
      compensatorstattype: 6,
      requestCountData: [],
      employeewalletbalancedata: [],
      unclaimedwalletbalancedata: [],
      totalbalance: 0,
      eefiltertypeid: 1,
      eesubfiltertypeid: 1,
      eesubfilterids: [],
    };

    this.selectFilter = this.selectFilter.bind(this);
  }

  componentDidMount() {
    this.getAdvanceWalletBalance();
    this.getExpenseDistribution();
    this.getExpenseHeatMap();
    this.getCompensatorStat();
    this.getTotalEmployeeExpenditure();
  }

  getAdvanceWalletBalance() {
    let name;
    instance
      .post("expensedashboard/advancewalletbalance", {
        subfiltertypeid: this.state.ldsubfiltertypeid,
        subfilterids:
          this.state.ldsubfilterids && this.state.ldsubfilterids.length > 0
            ? this.state.ldsubfilterids.join(",")
            : null,
        longestday: this.state.longestday,
      })
      .then((result) => {
        const employeewalletbalancedata = [];
        const unclaimedwalletbalancedata = [];
        result.data.result[0] &&
          result.data.result[0].emploeewalletbalance &&
          result.data.result[0].emploeewalletbalance.forEach((x) => {
            name = x.fullname;
            name = name.split(" ");
            name = `${name[0]} ${name[name.length - 1]}`;
            employeewalletbalancedata.push({
              Value: x.availbaleamount,
              name,
              displayvalue: x.availbaleamount,
              displayname: x.fullname,
            });
          });

        result.data.result[0] &&
          result.data.result[0].unclaimedwalletbalance &&
          result.data.result[0].unclaimedwalletbalance.forEach((x) => {
            unclaimedwalletbalancedata.push(x);
          });

        this.setState({
          employeewalletbalancedata,
          unclaimedwalletbalancedata,
          totalbalance:
            result.data.result[0] && result.data.result[0].totalbalance,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getCompensatorStat() {
    let name;
    instance
      .post("expensedashboard/compensatorstat", {
        filtertypeid: this.state.compensatorstattype,
      })
      .then((result) => {
        const data = [
          {
            reqdata: [],
            pendingrequestcount: result.data.result[0]
              ? result.data.result[0].pendingrequestcount
              : 0,
          },
        ];
        result.data.result[0] &&
          result.data.result[0].graph &&
          result.data.result[0].graph.forEach((d) => {
            name = d.fullname;
            name = name.split(" ");
            name = `${name[0]} ${name[name.length - 1]}`;
            data[0].reqdata.push({
              name,
              Value: d.avgtime,
              displayvalue: d.avgtime,
              displayname: d.fullname,
            });
          });
        this.setState({
          requestCountData: data,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getExpenseDistribution() {
    instance
      .post("expensedashboard/expensedistribution", {
        filtertypeid: this.state.wffiltertypeid,
        subfiltertypeid: this.state.wfsubfiltertypeid,
        subfilterids:
          this.state.wfsubfilterids && this.state.wfsubfilterids.length > 0
            ? this.state.wfsubfilterids.join(",")
            : null,
      })
      .then((result) => {
        const data = [];
        let sumExpenseDistribution = 0;
        const expensedistribution =
          result.data.result[0] &&
          result.data.result[0].graph.map((x) => {
            const objective = {};
            objective.id = x.labelname;
            sumExpenseDistribution += x.total;
            objective.data = x.data.map((y) => ({
              x: y.expensedate,
              y: y.expenseamount,
            }));
            data.push(objective);
          });
        this.setState({
          expensedistribution: data,
          averageexpense:
            result.data.result[0] && result.data.result[0].graph.length == 0
              ? 0
              : sumExpenseDistribution / result.data.result[0].graph.length,
          highestexpenditurelocation:
            result.data.result[0] && result.data.result[0].maximumExpenditure,
          maximumexpenditurmonth:
            result.data.result[0] &&
            result.data.result[0].maximumExpenditureMonth,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getExpenseHeatMap() {
    instance
      .post("expensedashboard/expenseheatmap", {
        filtertypeid: this.state.atfiltertypeid,
        subfiltertypeid: this.state.atsubfiltertypeid,
        subfilterids:
          this.state.atsubfilterids && this.state.atsubfilterids.length > 0
            ? this.state.atsubfilterids.join(",")
            : null,
      })
      .then((result) => {
        const expenseheatmap = result.data.result[0]
          ? result.data.result[0].graph.map((x) => ({
              day: x.expensedate,
              value: x.totalamount,
            }))
          : [];
        this.setState({
          expenseheatmap,
          fromdate: result.data.result[0]
            ? result.data.result[0].fromdate
            : null,
          todate: result.data.result[0] ? result.data.result[0].todate : null,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getTotalEmployeeExpenditure() {
    instance
      .post("expensedashboard/employeeexpenditure", {
        filtertypeid: this.state.eefiltertypeid,
        subfiltertypeid: this.state.eesubfiltertypeid,
        subfilterids:
          this.state.eesubfilterids && this.state.eesubfilterids.length > 0
            ? this.state.eesubfilterids.join(",")
            : null,
      })
      .then((result) => {
        const data = [];
        const employeeexpenditure = result.data.result[0]
          ? result.data.result[0].graph &&
            result.data.result[0].graph.forEach((x) => {
              data.push({
                displayname: x.subcategoryname,
                displayvalue: x.avgamount,
              });
            })
          : [];
        this.setState({
          employeeexpenditure: data,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  selectFilter(val, key) {
    this.setState(
      {
        [key]: val,
      },
      () => {
        if (key == "ldsubfilterids" || key == "ldsubfiltertypeid") {
          this.getAdvanceWalletBalance();
        } else if (
          key == "wffiltertypeid" ||
          key == "wfsubfilterids" ||
          (key == "wfsubfiltertypeid" && val == 1)
        ) {
          this.getExpenseDistribution();
        } else if (
          key == "atfiltertypeid" ||
          key == "atsubfilterids" ||
          (key == "atsubfiltertypeid" && val == 1)
        ) {
          this.getExpenseHeatMap();
        } else if (key == "compensatorstattype") {
          this.getCompensatorStat();
        } else if (
          key == "eefiltertypeid" ||
          key == "eesubfilterids" ||
          (key == "eesubfiltertypeid" && val == 1)
        ) {
          this.getTotalEmployeeExpenditure();
        }
      },
    );
  }

  render() {
    const {
      ldsubfiltertypeid,
      ldsubfilterids,
      eefiltertypeid,
      eesubfilterids,
      eesubfiltertypeid,
      wffiltertypeid,
      wfsubfilterids,
      wfsubfiltertypeid,
      atfiltertypeid,
      atsubfilterids,
      atsubfiltertypeid,
    } = this.state;
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
            <div className="display-flex">
              <div>
                <p
                  className="t-bold normal-dark margin-bottom-8"
                  style={{ width: 250 }}
                >
                  Expense distribution
                </p>
                {/* <p
                  className="small-dark-secondary margin-bottom-8"
                  style={{ fontSize: 10 }}
                >
                  Median value per employee
                </p> */}
              </div>

              <div
                className="width100 "
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <div className="width30 margin-right-8">
                  <DynamicForm
                    fields={selectinputconverter({
                      value: wffiltertypeid,
                      label: "",
                      options: [
                        ...requestCountTypes.filter((x) => x.displayvalue != 6),
                        ...filterTypes.filter(
                          (x) => x.displayvalue == 1 || x.displayvalue == 2,
                        ),
                      ],
                      disabled: false,
                    })}
                    onChange={(val) => this.selectFilter(val, "wffiltertypeid")}
                  />
                </div>
                <div className="margin-right-8 width30">
                  <DynamicForm
                    fields={selectinputconverter({
                      value: wfsubfiltertypeid,
                      label: "",
                      options: subfilterTypes,
                      disabled: false,
                    })}
                    onChange={(val) =>
                      this.selectFilter(val, "wfsubfiltertypeid")
                    }
                  />
                </div>
                {wfsubfiltertypeid && wfsubfiltertypeid != 1 && (
                  <div className="width30">
                    <DynamicForm
                      fields={multiselectinputconverter({
                        value: wfsubfilterids,
                        label: "",
                        options:
                          wfsubfiltertypeid == 2
                            ? this.props.businessUnits
                            : wfsubfiltertypeid == 3
                            ? this.props.departmentList
                            : wfsubfiltertypeid == 4
                            ? this.props.locationList
                            : [],
                        disabled: false,
                        idonly: true,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "wfsubfilterids")
                      }
                    />
                  </div>
                )}
              </div>
            </div>

            <Grid container style={{ marginTop: 24 }}>
              <Grid item xs={12} md={12} sm={12}>
                <div className="width100 display-flex">
                  <div style={{ paddingRight: 32 }}>
                    <p className="extra-small-dark-secondary">
                      Average total expense
                    </p>
                    <p className="normal-blue t-bold">
                      {this.state.averageexpense}
                    </p>
                  </div>
                  <div
                    style={{
                      marginRight: 40,
                      borderLeft: "1px solid #d9dadb",
                      paddingLeft: 32,
                    }}
                  >
                    <p className="extra-small-dark-secondary">
                      Highest expenditure location
                    </p>
                    <p className="normal-blue t-bold">
                      {this.state.highestexpenditurelocation}
                    </p>
                  </div>
                  <div
                    style={{
                      marginRight: 40,
                      borderLeft: "1px solid #d9dadb",
                      paddingLeft: 32,
                    }}
                  >
                    <p className="extra-small-dark-secondary">
                      Highest expenditure month
                    </p>
                    <p className="normal-blue t-bold">
                      {this.state.maximumexpenditurmonth}
                    </p>
                  </div>
                </div>
              </Grid>
            </Grid>
            <div
              style={{ height: 300, marginTop: 24, marginBottom: 24 }}
              className="line-data"
            >
              <p className="small-dark-secondary t-bold">
                Total expenses over time
              </p>
              <ResponsiveLineCanvas
                height={300}
                enablePointLabel={false}
                pointLabel="y"
                pointLabelYOffset={-12}
                useMesh={true}
                enableGridX={true}
                colors={["#d02dff"]}
                lineWidth={1}
                pointSize={4}
                data={
                  this.state.expensedistribution.length != 0
                    ? this.state.expensedistribution
                    : [
                        {
                          id: "Expence",
                          data: [{ x: moment().format("YYYY-MM-DD"), y: 0 }],
                        },
                      ]
                }
                margin={{
                  top: 20,
                  right: 80,
                  bottom: 26,
                  left: 55,
                }}
                axisLeft={{
                  orient: "left",
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Expense Amount",
                  legendOffset: -46,
                  legendPosition: "middle",
                }}
                enableLabel={true}
                enableGridY={true}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                isInteractive={true}
                xScale={{
                  type: "time",
                  format: "%Y-%m-%d",
                  precision: "day",
                }}
                xFormat="time:%Y-%m-%d"
                axisBottom={{
                  orient: "bottom",
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  format: "%b %d",
                  legend: "",
                  legendOffset: 23,
                  legendPosition: "middle",
                  tickValues: "every 1 week",
                }}
              />
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12} md={12} sm={12}>
          <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
            <Grid item xs={12} md={12} sm={12} className="display-flex">
              <p
                className="t-bold normal-dark margin-bottom-8"
                style={{ width: 250 }}
              >
                Advance wallet
              </p>
              <div
                className="width100"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <div className="margin-right-8 width30">
                  <DynamicForm
                    fields={selectinputconverter({
                      value: ldsubfiltertypeid,
                      label: "",
                      options: subfilterTypes,
                      disabled: false,
                    })}
                    onChange={(val) =>
                      this.selectFilter(val, "ldsubfiltertypeid")
                    }
                  />
                </div>
                {ldsubfiltertypeid && ldsubfiltertypeid != 1 && (
                  <div className="width30">
                    <DynamicForm
                      fields={multiselectinputconverter({
                        value: ldsubfilterids,
                        label: "",
                        options:
                          ldsubfiltertypeid == 2
                            ? this.props.businessUnits
                            : ldsubfiltertypeid == 3
                            ? this.props.departmentList
                            : ldsubfiltertypeid == 4
                            ? this.props.locationList
                            : [],
                        disabled: false,
                        idonly: true,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "ldsubfilterids")
                      }
                    />
                  </div>
                )}
              </div>
            </Grid>
            <p className="margin-bottom-4 extra-small-dark-secondary">
              Unused wallet amount
            </p>
            <div className="margin-bottom-16 normal-blue t-bold">
              {this.state.totalbalance}
            </div>
            <Grid container spacing={3}>
              <Grid item xs={6} md={8} sm={12}>
                <p className="small-dark-secondary t-bold margin-bottom-16">
                  Employees with wallet balance
                </p>

                <div style={{ height: 300 }}>
                  <ResponsiveBarCanvas
                    layout="horizontal"
                    data={
                      this.state.employeewalletbalancedata.length != 0
                        ? this.state.employeewalletbalancedata
                        : [
                            {
                              displayid: null,
                              name: "Employee Name",
                              displayvalue: 0,
                              Value: 0,
                            },
                          ]
                    }
                    keys={["Value"]}
                    indexBy={"name"}
                    pixelRatio={1}
                    padding={0.8}
                    margin={{
                      top: 10,
                      right: 50,
                      bottom: 36,
                      left: 100,
                    }}
                    minValue="0"
                    maxValue={
                      Math.max(
                        ...(this.state.employeewalletbalancedata.length != 0
                          ? this.state.employeewalletbalancedata.map(
                              (x) => x.displayvalue,
                            )
                          : []),
                      ) || "auto"
                    }
                    colors={["#0095ff"]}
                    enableLabel={true}
                    axisRight={null}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: "",
                      legendPosition: "middle",
                      legendOffset: -90,
                    }}
                    axisBottom={{
                      tickSize: 1,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: "Value",
                      tickValues:
                        Math.max(
                          ...(this.state.employeewalletbalancedata.length != 0
                            ? this.state.employeewalletbalancedata.map(
                                (x) => x.displayvalue,
                              )
                            : []),
                        ) > 2
                          ? 4
                          : 2,
                      legendPosition: "middle",
                      legendOffset: 30,
                    }}
                    enableGridX={true}
                    enableGridY={false}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                    isInteractive={true}
                  />
                </div>
              </Grid>
              <Grid item xs={6} md={4} sm={12}>
                <p className="small-dark-secondary t-bold margin-bottom-16">
                  Longest unclaimed balance
                </p>
                {this.state.unclaimedwalletbalancedata.length > 0 &&
                  this.state.unclaimedwalletbalancedata.map((listdata) => (
                    <div
                      className="display-flex"
                      style={{
                        borderBottom: "1px dashed #979797",
                        padding: "8px 0px",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="display-flex"
                        style={{ alignItems: "center" }}
                      >
                        <ProfilePicture
                          height={32}
                          src={getFormattedImageLink(listdata.imagepath)}
                          classname="margin-right-16"
                        />
                        <p className="small-dark-secondary t-bold">
                          {listdata.employeename || listdata.fullname}
                        </p>
                      </div>

                      <div>
                        <p className="small-dark-secondary t-bold">
                          {listdata.unclaimeddays} days
                        </p>
                      </div>
                    </div>
                  ))}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} md={12} sm={12}>
          <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
            <Grid container spacing={1}>
              <Grid item xs={12} md={2} sm={12}>
                <div className="t-bold normal-dark margin-bottom-8">
                  Expense heatmap
                </div>
              </Grid>
              <Grid item xs={12} md={10} sm={12}>
                <div
                  className="width100"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <div className="width30 margin-right-8">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: atfiltertypeid,
                        label: "",
                        options: [
                          ...requestCountTypes.filter(
                            (x) => x.displayvalue != 6,
                          ),
                          ...filterTypes.filter((x) => x.displayvalue != 5),
                        ],
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "atfiltertypeid")
                      }
                    />
                  </div>
                  <div className="margin-right-8 width30">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: atsubfiltertypeid,
                        label: "",
                        options: subfilterTypes,
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "atsubfiltertypeid")
                      }
                    />
                  </div>
                  {atsubfiltertypeid && atsubfiltertypeid != 1 && (
                    <div className="width30">
                      <DynamicForm
                        fields={multiselectinputconverter({
                          value: atsubfilterids,
                          label: "",
                          options:
                            atsubfiltertypeid == 2
                              ? this.props.businessUnits
                              : atsubfiltertypeid == 3
                              ? this.props.departmentList
                              : atsubfiltertypeid == 4
                              ? this.props.locationList
                              : [],
                          disabled: false,
                          idonly: true,
                        })}
                        onChange={(val) =>
                          this.selectFilter(val, "atsubfilterids")
                        }
                      />
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>

            <div style={{ height: 250 }} className="line-data">
              <ResponsiveCalendarCanvas
                height={250}
                data={this.state.expenseheatmap}
                from={this.state.fromdate}
                to={this.state.todate}
                emptyColor="#eeeeee"
                colors={[
                  "#d8d8d8",
                  "#2cd9c5",
                  "#97e3d6",
                  "#ffe700",
                  "#f86b07",
                  "#ff4052",
                ]}
                minValue={0}
                maxValue={"auto"}
                margin={{ top: 10, right: 10, bottom: 10, left: 20 }}
                yearSpacing={0}
                monthBorderWidth={0}
                monthBorderColor="#ffffff"
                dayBorderWidth={2}
                dayBorderColor="#ffffff"
                legends={[
                  {
                    anchor: "bottom-right",
                    direction: "row",
                    translateY: -16,
                    itemCount: 5,
                    itemWidth: 42,
                    itemHeight: 26,
                    itemsSpacing: 14,
                    itemDirection: "right-to-left",
                  },
                ]}
              />
            </div>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6} sm={12}>
          <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
            <div className="t-bold normal-dark margin-bottom-8">
              Total employee expenditure
            </div>
            <div
              className="width100"
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <div className="width30 margin-right-8">
                <DynamicForm
                  fields={selectinputconverter({
                    value: eefiltertypeid,
                    label: "",
                    options: [
                      ...requestCountTypes.filter((x) => x.displayvalue != 6),
                      ...filterTypes.filter(
                        (x) => x.displayvalue == 1 || x.displayvalue == 2,
                      ),
                    ],
                    disabled: false,
                  })}
                  onChange={(val) => this.selectFilter(val, "eefiltertypeid")}
                />
              </div>
              <div className="margin-right-8 width30">
                <DynamicForm
                  fields={selectinputconverter({
                    value: eesubfiltertypeid,
                    label: "",
                    options: subfilterTypes,
                    disabled: false,
                  })}
                  onChange={(val) =>
                    this.selectFilter(val, "eesubfiltertypeid")
                  }
                />
              </div>
              {eesubfiltertypeid && eesubfiltertypeid != 1 && (
                <div className="width30">
                  <DynamicForm
                    fields={multiselectinputconverter({
                      value: eesubfilterids,
                      label: "",
                      options:
                        eesubfiltertypeid == 2
                          ? this.props.businessUnits
                          : eesubfiltertypeid == 3
                          ? this.props.departmentList
                          : eesubfiltertypeid == 4
                          ? this.props.locationList
                          : [],
                      disabled: false,
                      idonly: true,
                    })}
                    onChange={(val) => this.selectFilter(val, "eesubfilterids")}
                  />
                </div>
              )}
            </div>

            {this.state.employeeexpenditure.length > 0 ? (
              <div className="doughnut-chart">
                {
                  <Doughnut
                    data={{
                      labels: this.state.employeeexpenditure.map(
                        (x) => x.displayname,
                      ),
                      datasets: [
                        {
                          label: "Average expenditure",
                          data: this.state.employeeexpenditure.map(
                            (x) => x.displayvalue,
                          ),
                          backgroundColor: [
                            "#2cd9c5",
                            "#f86b07",
                            "#d02dff",
                            "#826af9",
                            "#96f7df",
                            "#f7dc96",
                            "#d0f796",
                            "#e0f7fa",
                            "#eceff1",
                            "#efebe9",
                            "#d7ccc8",
                            "#cfd8dc",
                            "#e3f2fd",
                            "#fff9c4",
                            "#b2dfdb",
                            "#c8e6c9",
                            "#e0e0e0",
                            "#ffe0b2",
                            "#f3e5f5",
                          ],
                        },
                      ],
                    }}
                    width="150px"
                    height="100px"
                    options={{
                      rotation: 100,
                      animation: {
                        animateRotate: true,
                      },
                      tooltips: {
                        footerFontSize: 18,
                        titleFontSize: 18,
                        bodyFontSize: 18,
                      },
                      legend: {
                        display: true,
                        position: "right",
                        fullWidth: false,
                        labels: {
                          fontSize: 16,
                        },
                      },
                    }}
                  />
                }
              </div>
            ) : (
              <p className="small-dark-secondary">No data found</p>
            )}
          </Paper>
          <ShareIdea openForm={this.props.openForm} />
        </Grid>
        <Grid item xs={12} md={6} sm={12}>
          <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
            <div className="t-bold normal-dark margin-bottom-8">
              Compensator stats
            </div>
            <div className="width60">
              <DynamicForm
                fields={selectinputconverter({
                  value: this.state.compensatorstattype,
                  label: "",
                  options: requestCountTypes,
                  disabled: false,
                })}
                onChange={(val) =>
                  this.selectFilter(val, "compensatorstattype")
                }
              />
            </div>
            <div className="margin-bottom-8 extra-small-dark-secondary">
              Pending compensation requests
            </div>
            <div className="margin-bottom-8 t-bold normal-blue">
              {this.state.requestCountData[0]
                ? this.state.requestCountData[0].pendingrequestcount
                : "0"}
            </div>
            <p className="small-dark-secondary t-bold margin-bottom-16">
              Average expense compensation time
            </p>
            <div style={{ height: 218 }}>
              <ResponsiveBarCanvas
                layout="horizontal"
                data={
                  this.state.requestCountData[0]
                    ? this.state.requestCountData[0].reqdata
                    : [{ displayid: null, name: 0, displayvalue: 0, Value: 0 }]
                }
                keys={["Value"]}
                indexBy={"name"}
                pixelRatio={1}
                padding={0.8}
                margin={{
                  top: 10,
                  right: 10,
                  bottom: 36,
                  left: 80,
                }}
                minValue="0"
                maxValue={
                  Math.max(
                    ...(this.state.requestCountData[0]
                      ? this.state.requestCountData[0].reqdata.map(
                          (x) => x.displayvalue,
                        )
                      : []),
                  ) || "auto"
                }
                colors={["#0095ff"]}
                enableLabel={true}
                axisRight={null}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Value",
                  legendPosition: "middle",
                  legendOffset: -90,
                }}
                axisBottom={{
                  tickSize: 1,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "",
                  tickValues:
                    Math.max(
                      ...(this.state.requestCountData[0]
                        ? this.state.requestCountData[0].reqdata.map(
                            (x) => x.displayvalue,
                          )
                        : []),
                    ) > 2
                      ? 4
                      : 2,
                  legendPosition: "middle",
                  legendOffset: 30,
                }}
                enableGridX={true}
                enableGridY={false}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                isInteractive={true}
              />
            </div>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

export default Expense;
